// General
export const CLEAR_STORE = 'clear_store';
export const SHOW_MODAL = 'show_modal';
export const HIDE_MODAL = 'hide_modal';
export const COMPANY_NOTICE_SEEN_SUCCESS = 'company_notice_seen_success';
export const FETCH_ANALYTICS_DATA_SUCCESS = 'FETCH_ANALYTICS_DATA_SUCCESS';

// User
export const TEMP_SAVE_COGNITO_USER = 'temp_save_cognito_user';
export const LOGIN_SUCCESS = 'login_success';
export const LOGOUT_SUCCESS = 'logout_success';
export const CLEAR_USER_LOGIN_ERROR = 'clear_user_login_error';
export const SET_USER_LOGIN_ERROR = 'set_user_login_error';
export const USER_LOGIN = 'user_login';
export const USER_LOGIN_FAIL = 'user_login_fail';
export const FETCH_MY_PROFILE_SUCCESS = 'fetch_my_profile_success';
export const USER_REGISTER = 'user_register_up';
export const USER_REGISTER_SUCCESS = 'user_register_success';
export const USER_REGISTER_FAIL = 'user_register_fail';

export const CREATE_USER = 'create_user';
export const CREATE_USER_SUCCESS = 'create_user_success';
export const CREATE_USER_ERROR = 'create_user_error';

export const FETCH_COMPANY_USERS = 'fetch_company_users';
export const FETCH_COMPANY_USERS_SUCCESS = 'fetch_company_users_success';
export const FETCH_COMPANY_USERS_ERROR = 'fetch_company_users_error';

export const CHANGE_PASSWORD = 'change_password';
export const CHANGE_PASSWORD_SUCCESS = 'change_password_success';
export const CHANGE_PASSWORD_ERROR = 'change_password_error';
export const CLEAR_CHANGE_PW_ERROR = 'clear_change_pw_error';

export const FORGOT_PASSWORD_REQUEST = 'forgot_password_request';
export const FORGOT_PASSWORD_REQUEST_SUCCESS = 'forgot_password_request_success';
export const FORGOT_PASSWORD_REQUEST_ERROR = 'forgot_password_request_error';

export const FORGOT_PASSWORD_CONFIRM = 'forgot_password_confirm';
export const FORGOT_PASSWORD_CONFIRM_SUCCESS = 'forgot_password_confirm_success';
export const FORGOT_PASSWORD_CONFIRM_ERROR = 'forgot_password_confirm_error';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAIL = 'UPDATE_USER_PROFILE_FAIL';


// Post task
export const POST_TASK = 'post_task';
export const POST_TASK_SUCCESS = 'post_task_success';
export const POST_TASK_ERROR = 'post_task_error';

// Task details
export const FETCH_TASK_DETAILS = 'fetch_task_details';
export const FETCH_TASK_DETAILS_SUCCESS = 'fetch_task_details_success';
export const FETCH_TASK_DETAILS_ERROR = 'fetch_task_details_error';
export const CANCEL_TASK = 'cancel_task';
export const CANCEL_TASK_SUCCESS = 'cancel_task_success';
export const CANCEL_TASK_ERROR = 'cancel_task_error';
export const UPDATING_RATING_REVIEW = 'updating_rating_review';
export const UPDATING_RATING_REVIEW_SUCCESS = 'updating_rating_review_success';
export const UPDATING_RATING_REVIEW_FAIL = 'updating_rating_review_fail';
export const REQUEST_MORE_QUOTATION = 'request_more_quotation';
export const REQUEST_MORE_QUOTATION_SUCCESS = 'request_more_quotation_success';
export const REQUEST_MORE_QUOTATION_FAIL = 'request_more_quotation_fail';
export const ADD_PAYMENT_DETAILS = 'add_payment_details';
export const ADD_PAYMENT_DETAILS_SUCCESS = 'add_payment_details_success';
export const ADD_PAYMENT_DETAILS_ERROR = 'add_payment_details_error';
export const FETCH_INSPECTORS = 'fetch_inspectors';
export const FETCH_INSPECTORS_SUCCESS = 'fetch_inspectors_success';
export const FETCH_INSPECTORS_ERROR = 'fetch_inspectors_error';
export const UPDATE_TASK = 'update_task';
export const UPDATE_TASK_SUCCESS = 'update_task_success';
export const UPDATE_TASK_ERROR = 'update_task_error';
export const CONFIG_TASK_DETAILS = 'config_task_details';

export const SELECT_QUOTATION = 'select_quotation';
export const SELECT_QUOTATION_SUCCESS = 'select_quotation_success';
export const SELECT_QUOTATION_FAIL = 'select_quotation_fail';
export const TASK_NOTICE_SEEN_SUCCESS = 'task_notice_seen_success';

// tasks
export const FETCH_TASKS = 'fetch_tasks';
export const FETCH_TASKS_SUCCESS = 'fetch_tasks_success';
export const FETCH_TASKS_FAIL = 'fetch_tasks_fail';

// activities
export const FETCH_ACTIVITIES = 'fetch_activities';
export const FETCH_ACTIVITIES_SUCCESS = 'fetch_activities_success';
export const FETCH_ACTIVITIES_ERROR = 'fetch_activities_error';

// Tasks history
export const FETCH_TASKS_HISTORY = 'fetch_tasks_history';
export const FETCH_TASKS_HISTORY_SUCCESS = 'fetch_tasks_history_success';
export const FETCH_TASKS_HISTORY_ERROR = 'fetch_tasks_history_error';

// Notificaitons
export const FETCH_NOTIFICATION = 'fetch_notification';
export const FETCH_NOTIFICATION_SUCCESS = 'fetch_notification_success';
export const PAGINATE_NOTIFICATION = 'paginate_notification';
export const PAGINATE_NOTIFICATION_SUCCESS = 'paginate_notification_success';
export const FETCH_NOTIFICATION_FAIL = 'fetch_notification_fail'
export const NOTIFICATION_SEEN = 'notification_seen';
export const ALL_NOTIFICATION_SEEN_SUCCESS = 'all_notification_seen_success';

export const RECEIVE_GENERAL_NOTIFICATIONS = 'receive_general_notifications';
export const RECEIVE_NOTICE_TASK_NOTIFICATION = 'receive_notice_task_notification';
export const RECEIVE_NOTICE_COMPANY_NOTIFICATION = 'receive_notice_company_notification';

// Vehicles
export const FETCH_VEHICLES = 'fetch_vehicles';
export const FETCH_VEHICLES_SUCCESS = 'fetch_vehicles_success';
export const FETCH_VEHICLE_DETAILS = 'fetch_vehicle_details';
export const FETCH_VEHICLE_DETAILS_SUCCESS = 'fetch_vehicle_details_success'
export const ADD_NEW_VEHILCE = 'add_new_vehicle'
export const ADD_NEW_VEHILCE_SUCCESS = 'add_new_vehicle_success'
export const ADD_NEW_VEHILCE_SERVICE = 'add_new_vehicle_service'
export const ADD_NEW_VEHILCE_SERVICE_SUCCESS = 'add_new_vehicle_service_success'